import React from "react";
import "./SocialMedia.scss";
import {socialMediaLinks} from "../../portfolio";
import { TbBrandLeetcode } from "react-icons/tb";
export default function socialMedia({footer}) {
  if (!socialMediaLinks.display) {
    return null;
  }
  return (
    <div className={footer ? "social-media-div-footer" : "social-media-div" }>
      {socialMediaLinks.github ? (
        <a
          href={socialMediaLinks.github}
          className="icon-button github"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-github"></i>
          <span></span>
        </a>
      ) : null}

      {socialMediaLinks.linkedin ? (
        <a
          href={socialMediaLinks.linkedin}
          className="icon-button linkedin"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-linkedin-in"></i>
          <span></span>
        </a>
      ) : null}

      {socialMediaLinks.gmail ? (
        <a
          href={`mailto:${socialMediaLinks.gmail}`}
          className="icon-button google"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-envelope"></i>
          <span></span>
        </a>
      ) : null}
       
          {socialMediaLinks.leetcode ? (
        <a
          href={socialMediaLinks.leetcode}
          className="icon-button leetcode"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-code"></i>
          <span></span>
        </a>
      ) : null}
   


    </div>
  );
}
